import { Chip, Stack, Typography } from '@mui/material';
import React from 'react';
import { match } from 'ts-pattern';
import TablerIconFiles from '~icons/tabler/files';
import { GitHubFileTreeView } from '#/features/github';
import ChatMessagePartToolContainer from './chat-message-part-tool-container';
import type { ChatMessagePartToolBaseProps } from './types';

export type ChatMessagePartToolGitHubTreeReadProps =
  ChatMessagePartToolBaseProps<'github-tree-read'>;

function ChatMessagePartToolGitHubTreeRead({
  toolInvocation,
  compact,
  defaultOpen,
  card,
  onEngage,
}: ChatMessagePartToolGitHubTreeReadProps) {
  const { args } = toolInvocation;

  return match(toolInvocation)
    .with(
      { state: 'result', result: { status: 'success' } },
      ({ result: { result }, args }) => {
        return (
          <ChatMessagePartToolContainer
            icon={<TablerIconFiles />}
            compact={compact}
            defaultOpen={defaultOpen}
            card={card}
            title={
              <Stack
                direction='row'
                alignItems='center'
                spacing={1}
                className='w-full pr-2'
              >
                <Typography variant='body2'>File Tree</Typography>
                {result.truncated && (
                  <div className='text-sm text-divider'>(truncated)</div>
                )}
                <div className='flex-1 min-h-1 min-w-2' />
                <Chip
                  size='xsmall'
                  shape='rounded'
                  label={`${result.repo}/${result.owner}`}
                />
              </Stack>
            }
            status='result'
            onToggle={() => {
              onEngage?.('engage');
            }}
          >
            <div className='max-h-[480px] overflow-y-auto'>
              <GitHubFileTreeView
                fileTree={{
                  sha: result.sha,
                  truncated: false,
                  tree: result.tree.map((file) => ({
                    path: file.path,
                    sha: file.sha,
                    type: file.type as 'file' | 'directory',
                  })),
                }}
                onSelectedItemsChange={(fileTreeNode) => {
                  onEngage?.('engage');
                }}
                onItemExpansionToggle={(fileTreeNode) => {
                  onEngage?.('engage');
                }}
                showEmptyDirectories
                className='size-full max-w-full'
              />
            </div>
          </ChatMessagePartToolContainer>
        );
      }
    )
    .with({ state: 'result', result: { status: 'error' } }, () => null)
    .otherwise(() => {
      return (
        <ChatMessagePartToolContainer
          icon={<TablerIconFiles />}
          card={card}
          title='Loading GitHub file tree...'
          status='loading'
        />
      );
    });
}

export default React.memo(ChatMessagePartToolGitHubTreeRead);
